<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">SYSTEM</div>
          <div class="eng-font">评价制度</div>
        </div>
      </div>

      <div class="certificate-list-right">
        <div class="titleList">
          <div
            class="title"
            v-for="(item, index) in titleList"
            :key="item.id || index"
            @mouseenter="enter(index)"
            @mouseleave="leave()"
            @click="toDetail(index)"
          >
            <div :class="styleFlag == index ? 'title-left2' : 'title-left1'">
              {{ item.tm.Y }}.{{ item.tm.M }}.{{ item.tm.D }}
            </div>
            <div class="title-right">
              <div class="title-title">{{ item.name }}</div>
              <div class="title-brief">{{ item.brief }}</div>
            </div>
          </div>
        </div>
        <div class="title-page">
          <div class="flex">
            <div
              v-for="index of page.pageCount"
              :key="index"
              class="box"
              :class="pageIndex == index ? 'active' : ''"
              @click="pagetap(index)"
            >
              {{ index }}
            </div>
          </div>
          <div
            class="box title-page-active"
            @click="pageto()"
            style="width: 150px"
          >
            下一页
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Article, timestampToTime } from "../../services/article";
import { CATEGORY_ID_MAP } from "./loadCategoryArticle";

const CATEGORY_ID = CATEGORY_ID_MAP["评价制度"];

export default {
  data() {
    return {
      pageIndex: 1,
      styleFlag: -1,
      titleList: [],
      page: {
        totalCount: 0,
        pageCount: 1,
        currentPage: 1,
        perPage: 8,
      },
    };
  },
  mounted() {
    this.pagetap(1);
  },
  methods: {
    enter(index) {
      this.styleFlag = index;
    },
    leave() {
      this.styleFlag = -1;
    },
    toDetail(index) {
      const item = this.titleList[index];
      if (item.content && item.content.length < 100 && item.attachment) {
        window.open(item.attachment, "_blank");
        return;
      }
      this.$router.push({
        path: "/certificate-active",
        query: {
          id: item.id,
          category_id: item.category_id || CATEGORY_ID,
        },
      });
      this.leave();
    },
    pagetap(page) {
      this.pageIndex = page;
      this.titleList = [];
      Article({
        category_id: CATEGORY_ID,
        page_size: this.page.perPage,
        page: page,
      }).then((res) => {
        if (!res || !res.items) return;
        const titleList = [];
        res.items.forEach((citem) => {
          citem.tm = timestampToTime(
            new Date(citem.release_time).getTime() / 1000
          );
          titleList.push(citem);
        });
        this.titleList = titleList;
        if (res._meta) {
          this.page.totalCount = res._meta.totalCount;
          this.page.pageCount = res._meta.pageCount || 1;
          this.page.currentPage = res._meta.currentPage;
        }
      });
    },
    pageto() {
      if (this.pageIndex == this.page.pageCount) {
        this.pageIndex = 1;
      } else {
        this.pageIndex = this.pageIndex + 1;
      }
      this.pagetap(this.pageIndex);
    },
  },
};
</script>

<style scoped>
.partner {
  background-color: white;
}
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.certificate-list-left {
  float: left;
  width: 185px;
}
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}
.eng {
  font-size: 16px;
  color: #666666;
}
.eng-font {
  font-size: 26px;
}
.titleList {
  height: auto;
  width: auto;
  margin-top: 30px;
}
.title {
  display: flex;
  margin-left: 50px;
  width: auto;
  height: 85px;
}
.title:hover {
  background-color: #0055d3;
  color: #e6e6e6;
  cursor: pointer;
}
.title-left1 {
  color: #0055d3;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-left2 {
  color: #e6e6e6;
  height: auto;
  width: 175px;
  font-size: 32px;
  font-weight: bold;
  padding-top: 10px;
  padding-left: 25px;
}
.title-right {
  height: auto;
  padding-top: 13px;
  margin-left: 12px;
  vertical-align: middle;
  line-height: 30px;
}
.title-title {
  font-size: 18px;
  font-weight: bold;
}
.title-brief {
  font-size: 14px;
}
.title-page {
  display: flex;
  justify-content: space-between;
  width: auto;
  padding: 0px 20px 0px 75px;
  margin: 90px 0px 70px;
}
.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}
.box:hover {
  cursor: pointer;
}
.title-page .flex {
  display: flex;
}
.title-page .active {
  color: #fff;
  background: #0055d3;
}
.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
</style>
